import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { PrivateRoute } from "@/components/auth/PrivateRoute";
import Dashboard from "@/pages/Dashboard";

export const Route = createFileRoute("/dashboard")({
  head: () => seoHead({
    title: "Meu Painel | Shopping do Bem",
    description: "Acompanhe suas compras e doações.",
    path: "/dashboard", noindex: true,
  }),
  component: () => (
    <PrivateRoute>
      <Dashboard />
    </PrivateRoute>
  ),
});
